module.exports = "<rx-date-picker #datePicker [value]=\"value\" [disableWeekDays]=\"disableWeekDays\" [highlightWeekDays]=\"highlightWeekDays\" [datesDisabled]=\"datesDisabled\" [style.display]=\"viewMode === 'Date' ? '' : 'none'\" [weekStart]=\"weekStart\"></rx-date-picker>\r\n<rx-month-picker [month]=\"month\" [year]=\"year\" [style.display]=\"viewMode === 'Month' ? '' : 'none'\" (monthClick)=\"datePicker.show($event)\"></rx-month-picker>\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rx/forms/datepicker/rx_picker_control_component.html
// module id = ./node_modules/@rx/forms/datepicker/rx_picker_control_component.html
// module chunks = vendor